import React from 'react';
import styled, { keyframes } from 'styled-components';

const comboAppear = keyframes`
  0%   { transform: translate(-50%, -50%) scale(0.6); opacity: 0; }
  40%  { transform: translate(-50%, -50%) scale(1.2); opacity: 1; }
  100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
`;

const judgeAppear = keyframes`
  0%   { transform: translate(-50%, -50%) scale(0.8); opacity: 0; }
  40%  { transform: translate(-50%, -50%) scale(1.2); opacity: 1; }
  100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
`;

const CurrentCombo = styled.div`
  position: absolute;
  top: 44%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Arial', sans-serif;
  font-size: 1.0rem;
  color: #00eaff;
  font-weight: bold;
  text-shadow: 0 0 10px #000;
  z-index: 10;
  pointer-events: none;
  animation: ${comboAppear} 0.4s ease-out;
  
  @media (max-width: 768px) {
    font-size: 1.3rem;
    top: 42%;
  }
`;

const ScoreDisplay = styled.div`
  position: absolute;
  top: 75px;
  left: 15px;
  color: #fff;
  font-family: 'Arial', sans-serif;
  font-size: 1rem;
  font-weight: bold;
  text-shadow: 0 0 10px #000;
  z-index: 10;
  pointer-events: none;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    top: 60px;
    left: 10px;
  }
`;

const MaxComboDisplay = styled.div`
  position: absolute;
  top: 100px;
  left: 15px;
  color: #ffd700;
  font-family: 'Arial', sans-serif;
  font-size: 0.9rem;
  font-weight: bold;
  text-shadow: 0 0 10px #000;
  z-index: 10;
  pointer-events: none;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    top: 80px;
    left: 10px;
  }
`;

const RoundInfo = styled.div`
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 1.1rem;
  font-weight: bold;
  text-shadow: 0 0 10px #000;
  z-index: 10;
  pointer-events: none;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    top: 25px;
  }
`;

const ModeInfo = styled.div`
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  color: #ffd700;
  font-size: 0.9rem;
  font-weight: bold;
  text-shadow: 0 0 10px #000;
  z-index: 10;
  pointer-events: none;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    top: 45px;
  }
`;

const judgeColors = {
  Perfect: '#00ffe1',
  Good: '#ffff66',
  Miss: '#ff3b3b',
};

const JudgeMessage = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.7);
  letter-spacing: 0.05em;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  transform: translate(-50%, -50%);
  font-size: 2.4rem;
  color: ${({ result }) => judgeColors[result] || '#fff'};
  text-shadow:
    0 0 5px ${({ result }) => judgeColors[result] || '#fff'},
    0 0 10px ${({ result }) => judgeColors[result] || '#fff'},
    0 0 20px ${({ result }) => judgeColors[result] || '#fff'};
  white-space: nowrap;
  pointer-events: none;
  z-index: 20;
  animation: ${judgeAppear} 0.4s ease-out;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    top: 35%;
  }
`;

const BottomSpacer = styled.div`
  width: 100%;
  height: 80px;
  @media (max-width: 768px) {
    height: 60px;
  }
`;

const RhythmUI = ({
  judgeMessage,
  judgeKey,
  combo,
  showCombo,
  showResult,
  currentRound,
  totalRounds,
  gameMode,
  score,
  maxCombo
}) => {
  return (
    <>
      {judgeMessage && (
        <JudgeMessage result={judgeMessage} key={judgeKey}>{judgeMessage}</JudgeMessage>
      )}
      {combo > 1 && showCombo && !showResult && (
        <CurrentCombo>{combo} COMBO</CurrentCombo>
      )}
             <>
         <RoundInfo>Round {currentRound}/{totalRounds}</RoundInfo>
         <ModeInfo>{gameMode.toUpperCase()}</ModeInfo>
         {!showResult && (
           <>
             <ScoreDisplay>Score: {score?.toLocaleString() || 0}</ScoreDisplay>
             <MaxComboDisplay>Max Combo: {maxCombo || 0}</MaxComboDisplay>
           </>
         )}
       </>
      <BottomSpacer />
    </>
  );
};

export default RhythmUI;
